import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import '../../../static/css/pages/parents/tuition/tuition.css';
import {CurrencyFormat, NumberToPersianLetters} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {useNavigate} from "react-router-dom";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const ParentsChooseExtraPriceModal = (props: {
    active: boolean,
    closeHandler: any,
    title: string,
    paymentNd: string,
}) => {
    const [price, setPrice] = useState('');
    const [priceErr, setPriceErr] = useState(''); // error message in persian, '' => no errors
    const priceId = useId();
    const navigate = useNavigate();
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setPrice('');
            setPriceErr('');
        } else {
            document.body.classList.remove("body-no-scroll");
        }
    }, [props.active]);
    const generateInvoice = () => {
        const _price = price;
        if (_price === '' || _price === 'NaN') {
            setPriceErr('لطفا مبلغ را وارد کنید.');
            return;
        }
        const priceInt = parseInt(_price);
        if (priceInt < 1) {
            setPriceErr(`مبلغ وارد شده صحیح نمی‌باشد.`);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/extra/issue',
            {
                nd: props.paymentNd,
                p: _price,
            },
            true,
            (d: {
                result: string,
                reason: string,
                nd: string,
                min: number,
                max: number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    else if (d.reason === 'min-max') {
                        ShowSnackbar(
                            `مبلغ باید بین ${CurrencyFormat(d.min)} و ${CurrencyFormat(d.max)} تومان باشد.`,
                            'باشه',
                            5000,
                        );
                    }
                    return;
                }
                ShowSnackbar(
                    'می‌توانید فاکتور ایجاد شده را پرداخت نمایید.',
                    'باشه',
                    5000,
                );
                navigate(`/students/extra/invoice/${d.nd}`);
            },
            () => {
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top: 20}}>
                <div className="web-modal-header">
                    <div>
                        <b>{props.title}</b>
                    </div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="pay-tuition-modal">
                        <label htmlFor={priceId}>مبلغی که می‌خواهید پرداخت کنید:</label>
                        <input type="number"
                               className={"form-control text-center" + (priceErr === '' ? '' : ' is-invalid')}
                               value={price}
                               step={1000}
                               min={1000}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setPrice(t);
                                   setPriceErr('');
                               }}
                               onKeyUp={e => {
                                   if (e.which === 13)
                                       generateInvoice();
                               }}
                        />
                        {
                            price !== '' ?
                                <span style={{
                                    display: 'block',
                                    margin: '5px 0 0 0',
                                    fontWeight: 400,
                                    color: '#0a53be'
                                }}>
                                       {NumberToPersianLetters(parseInt(price)) + " تومان"}
                                   </span> : null
                        }
                        <div className={"invalid-feedback " + (priceErr === '' ? 'd-none' : 'd-block')}>{priceErr}</div>
                        <div className="d-flex justify-content-end align-items-center"
                             style={{gap: 10, marginTop: 30}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={generateInvoice}>
                                <b>ادامه پرداخت</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};